module.exports = __webpack_public_path__ + "static/media/rainbow.fa2fbab8.svg";